import landingPage from './landingPage.js';
import { onDOMContentLoaded } from '../../dom/events';

onDOMContentLoaded(() => landingPage.init());